import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'
import { type ToastItem, type ToastTone, useToastStore } from './store'

const byTone: Record<ToastTone, string> = {
  info: 'border-border-strong text-text-primary',
  success: 'border-border-default text-success',
  error: 'border-border-accent text-accent',
}

function ToastCard({ item, onDismiss }: { item: ToastItem; onDismiss: () => void }) {
  return (
    <div
      role="status"
      className={cn(
        'pointer-events-auto flex items-center gap-3 rounded-control border bg-bg-elevated px-4 py-3 font-mono text-sm',
        byTone[item.tone],
      )}
    >
      <span>{item.message}</span>
      {item.action && (
        <>
          <span aria-hidden className="text-text-tertiary">
            ·
          </span>
          <button
            type="button"
            onClick={() => {
              item.action?.onClick()
              onDismiss()
            }}
            className="uppercase tracking-wide text-text-primary transition-colors hover:text-accent"
          >
            {item.action.label}
          </button>
        </>
      )}
      <button
        type="button"
        aria-label="Закрыть"
        onClick={onDismiss}
        className="text-text-tertiary transition-colors hover:text-text-primary"
      >
        <Icon name="close" size={16} />
      </button>
    </div>
  )
}

export function ToastViewport() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)
  const bottom = toasts.filter((t) => t.placement === 'bottom')
  const top = toasts.filter((t) => t.placement === 'top')

  return (
    <>
      <div
        data-testid="toast-top"
        className="pointer-events-none fixed inset-x-0 top-6 z-50 flex flex-col items-center gap-2"
        aria-live="polite"
      >
        {top.map((t) => (
          <ToastCard key={t.id} item={t} onDismiss={() => dismiss(t.id)} />
        ))}
      </div>
      <div
        data-testid="toast-bottom"
        // На мобиле снизу стоит таймер-бар (h-14) + safe-area: тост встаёт над ними,
        // иначе перекрывает индикатор трекинга и уезжает под home-indicator.
        className="pointer-events-none fixed inset-x-0 bottom-[calc(4.5rem+env(safe-area-inset-bottom))] z-50 flex flex-col items-center gap-2 md:bottom-6"
        aria-live="polite"
      >
        {bottom.map((t) => (
          <ToastCard key={t.id} item={t} onDismiss={() => dismiss(t.id)} />
        ))}
      </div>
    </>
  )
}
